import React from "react"
import { useNavigate } from 'react-router-dom';
import Chip from "../chip/Chip"

export default function ResearchHeader({ type, title, date, author }) {

    const navigate = useNavigate();
    return (
        <div className="w-full h-full flex flex-col items-center justify-center bg-white px-[2rem] md:px-[8rem] lg:px-[14rem] py-[3rem]">
            <div>
                <span className="text-[1.275rem] font-medium font-roboto text-darkgray ">
                    {type}
                </span>
            </div>
            <div className="w-full items-center justify-center">
                <p className="text-[2rem] leading-none text-black font-roboto font-medium text-center pt-[1rem] pb-[1rem]">
                    {title}
                </p>
            </div>
            <div className="w-full flex items-center justify-center">
                <span className="text-[1.1rem] font-normal font-roboto text-black text-center">
                    {date} | {author}
                </span>
            </div>

            <div className="flex items-center justify-items-center py-[1rem] gap-x-8">
                <Chip
                    onClick={() => {navigate("#")}}
                    label="Read Paper"
                    largeFont
                    className="bg-primary text-white rounded-full"
                />
                <Chip
                    onClick={() => {navigate("#")}}
                    label="Access Repository"
                    largeFont
                    className="bg-primary text-white rounded-full"
                />
            </div>
        </div>
    )

}